import React, { useState, useEffect } from "react";
import InputWithLabel from "../Components/InputComponent/InputWithLabel";
import "react-quill/dist/quill.snow.css";
import { editProduct, updateProduct } from "../../services/ListProduct/ListProduct";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

const ProductEditModal = ({ isOpen, onClose, productId, onUpdate }) => {
    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        if (isOpen && productId) {
            fetchProductDetails();
        }
    }, [isOpen, productId]);

    const fetchProductDetails = async () => {
        setIsLoading(true);
        try {
            const response = await editProduct({ product_id: productId });
            if (response?.data) {
                setFormData(response.data);
            } else {
                throw new Error("Failed to fetch Product details.");
            }
        } catch (error) {
            console.error("Error fetching Product details:", error);
            showErrorToast(error.response?.data?.message || "Error fetching Product details.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        if (!formData?.name) {
            showErrorToast("Product content cannot be empty.");
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = { product_id: productId, ...formData };
            const response = await updateProduct({ payload });

            if (response?.status?.code === 200) {
                showSuccessToast(response.status.message || "Product details updated successfully!");
                onClose(); // Close the modal
                if (onUpdate) onUpdate(); // Trigger parent component refresh
            } else {
                throw new Error(response?.status?.message || "Failed to update Product.");
            }
        } catch (error) {
            console.error("Error updating Product:", error);
            showErrorToast(error.response?.data?.message || "Error updating Product details.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md overflow-auto">
                <div className="p-4 border-b flex justify-between items-center">
                    <h2 className="text-xl font-bold">Edit Product</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <div className="p-2">
                    {isLoading ? (
                        <p className="text-center text-gray-500">Loading...</p>
                    ) : (
                        formData && (
                            <div>
                                <InputWithLabel
                                    DivclassName="md:w-1/4"
                                    label="Product Name"
                                    type="text"
                                    name="name"
                                    placeholder="Enter Product Name"
                                    value={formData.name || ""}
                                    onChange={handleChange}
                                />
                            </div>
                        )
                    )}
                </div>
                <div className="p-4 border-t flex justify-end space-x-2 mt-12">
                    <button
                        onClick={onClose}
                        className="bg-red-500 text-white px-2 py-1 rounded-md"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={`bg-blue-500 text-white px-2 py-1 rounded-md ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        disabled={isSubmitting || isLoading}
                    >
                        {isSubmitting ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductEditModal;
